import cx from 'clsx';
import displayStyles from 'styles/global/display.module.scss';
import React, { FunctionComponent, useState } from 'react';
import styles from './MobileNavigation.module.scss';
import { Block, LinkWrapper } from 'components/elements';
import { Hamburger } from 'components/presentional';
import { HeaderTop } from 'components/presentional';
import { ReactComponent as Logo } from './logo.svg';
import { WPMenu } from 'types/menus';
import utilityStyles from 'styles/global/utility.module.scss';
import { useCurrentWidth } from 'hooks/dom';
import { useEffect } from 'react';
import LanguagePicker from '../LanguagePicker/LanguagePicker';

interface OwnProps {
  topMenu?: WPMenu;
  mainMenu?: WPMenu;
}

type MobileNavigationProps = Omit<JSX.IntrinsicElements['div'], 'menu'> & OwnProps;

const MobileNavigation: FunctionComponent<MobileNavigationProps> = props => {
  const { topMenu, mainMenu, className, ...rest } = props;
  const [opened, setOpened] = useState(false);
  const windowWidth = useCurrentWidth();

  useEffect(() => {
    setOpened(false);
  }, [windowWidth]);

  const wrapperClassName = cx({
    [styles.wrapper]: true,
    ...(className && { [className]: true }),
  });

  const containerClassName = cx({
    [styles.list]: true,
    [styles.listOpened]: opened,
  });

  const navClassName = cx({
    [styles.nav]: true,
  });

  const logoClassNames = cx({
    [displayStyles.centerVertical]: true,
    [styles.logo]: true,
  });

  return (
    <div className={wrapperClassName} {...rest}>
      <Block direction="row" theme="dark" className={utilityStyles.elevation1}>
        <LinkWrapper href="/" className={logoClassNames} aria-label="TestArmy logo">
          <Logo />
        </LinkWrapper>
        <LanguagePicker />
        <Hamburger opened={opened} onClick={() => setOpened(!opened)} />
      </Block>

      <div className={containerClassName}>
        <nav className={navClassName}>
          {mainMenu && <HeaderTop role="navigation" aria-label="Mobile top menu" onItemClick={() => setOpened(false)} menu={mainMenu} />}
          {topMenu && <HeaderTop role="navigation" aria-label="Mobile bottom menu" onItemClick={() => setOpened(false)} menu={topMenu} />}
          {/* <div className={styles.language}>
            <LanguagePicker />
          </div> */}
        </nav>
      </div>
    </div>
  );
};

export default MobileNavigation;
